package se.mittpass.web.components

import se.mittpass.web.*
import se.mittpass.web.components.*
import se.mittpass.web.pages.*
import se.mittpass.web.viewmodel.*
import se.mittpass.web.style.*


import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import se.mittpass.shared.api.AttendanceDto

@Composable
internal fun PliggarWeekView(
    weekStart: String,
    recordsByDay: Map<String, List<AttendanceDto>>,
    onEditRecord: (AttendanceDto) -> Unit
) {
    val today = todayLocalDate()

    Div({ style {
        property("overflow-x", "auto")
    } }) {
        Div({ style {
            property("display", "grid")
            property("grid-template-columns", "repeat(7, minmax(140px, 1fr))")
            property("gap", "0.5rem")
            property("min-width", "700px")
        } }) {
            for (d in 0..6) {
                val cellDate = addDays(weekStart, d)
                val dayRecs = recordsByDay[cellDate].orEmpty()
                val isToday = cellDate == today
                val dateParts = cellDate.split("-")
                val dayNum = dateParts[2].toInt()
                val monthIdx = dateParts[1].toInt() - 1

                Div({ style {
                    property("display", "flex"); property("flex-direction", "column"); property("gap", "0.4rem")
                } }) {
                    // Header chip
                    Div({ style {
                        property("display", "flex"); property("align-items", "center"); property("justify-content", "space-between")
                        property("padding", "0.5rem 0.75rem"); property("border-radius", "10px")
                        property("background", if (isToday) "var(--rp-pine)" else "var(--rp-overlay)")
                    } }) {
                        Span({ style {
                            property("font-weight", "700"); property("font-size", "0.82rem")
                            property("color", if (isToday) "#FFFFFF" else "var(--rp-subtle)")
                        } }) { Text(DAY_NAMES_SHORT[d]) }
                        Span({ style {
                            property("font-weight", "700"); property("font-size", "0.82rem")
                            property("color", if (isToday) "#FFFFFF" else "var(--rp-text)")
                        } }) { Text("$dayNum ${MONTH_NAMES[monthIdx].take(3)}") }
                        if (dayRecs.isNotEmpty()) {
                            Span({ style {
                                property("background", if (isToday) "rgba(255,255,255,0.3)" else "var(--rp-hl-med)")
                                property("color", if (isToday) "#FFFFFF" else "var(--rp-subtle)")
                                property("border-radius", "20px"); property("padding", "0.1rem 0.45rem")
                                property("font-size", "0.7rem"); property("font-weight", "700")
                            } }) { Text("${dayRecs.size}") }
                        }
                    }

                    // Records
                    if (dayRecs.isEmpty()) {
                        Div({ style {
                            property("padding", "0.75rem"); property("text-align", "center")
                            property("color", "var(--rp-hl-med)"); property("font-size", "0.8rem")
                        } }) { Text("–") }
                    } else {
                        dayRecs.forEach { rec ->
                            val name = listOfNotNull(rec.firstName, rec.lastName).joinToString(" ")
                                .ifEmpty { rec.userEmail.substringBefore("@") }
                            val inTime = rec.checkInTime.substringAfter("T").take(5)
                            val outTime = rec.checkOutTime?.substringAfter("T")?.take(5)
                            val missing = outTime == null

                            Div({
                                onClick { onEditRecord(rec) }
                                style {
                                    property("padding", "0.5rem 0.65rem"); property("border-radius", "10px")
                                    property("cursor", "pointer")
                                    property("background", if (missing) "var(--rp-err-bg)" else "var(--rp-ok-bg)")
                                    if (missing) property("border-left", "3px solid var(--rp-err-border)")
                                    else property("border-left", "3px solid var(--rp-ok-border)")
                                }
                            }) {
                                Div({ style {
                                    property("font-weight", "700"); property("font-size", "0.8rem")
                                    property("color", "var(--rp-text)"); property("margin-bottom", "0.2rem")
                                    property("white-space", "nowrap"); property("overflow", "hidden"); property("text-overflow", "ellipsis")
                                } }) { Text(name) }
                                Div({ style {
                                    property("font-size", "0.75rem"); property("font-weight", "600")
                                    property("color", if (missing) "var(--rp-err-text)" else "var(--rp-ok-text)")
                                } }) {
                                    Text("$inTime → ${outTime ?: "saknar ut"}")
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
